module.exports = __webpack_public_path__ + "static/media/loadhub.7a3e9b70.png";